<footer>
  <div class="footer-background-image">
    <ng-container *ngIf="data$ | async as data">
      <ion-button (click)="scrollTop()" [class.type-form]="isTypeform(iframeURL)" id="button" color="light"
        class="back-to-top-button">
        <i class="icon-chevron-up"></i>
      </ion-button>

      <ng-container *ngIf="newsletterInfo$ | async as newsletterInfo">
        <div *ngIf="newsletterInfo.subscription !== undefined && newsletterInfo.subscription.imageUrl !== ''"
          class="footer-top-row">
          <ion-grid class="container">
            <ion-row class="ion-justify-content-between ion-align-items-center">
              <ion-col size-xs="12" size-sm="auto">
                <h5>{{ 'FOOTER.NEWSLETTER_TITLE' | translate }}</h5>
                <p>{{ 'FOOTER.NEWSLETTER_SUBTITLE' | translate: { tenantName: tenantName } }}</p>
              </ion-col>

              <ion-col size-xs="12" size-sm="auto">
                <ion-button [class.button-subscribe]="isTypeform(iframeURL)" (click)="presentNewsletterModal()"
                  fill="outline">{{ 'ACTIONS.SUBSCRIBE' | translate }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ng-container>

      <div class="footer-middle-row">
        <ion-grid class="container">
          <ion-row class="ion-justify-content-between ion-align-items-end">
            <ion-col class="data-list" size-xs="12" size-sm="6" size-md="6" size-lg="auto">
              <div *ngIf="tenantLogo$ | async as tenantLogo"
                [ngStyle]="{ 'background-image': 'url(' + tenantLogo + ')' }" class="logos"></div>
              <ion-list lines="none">
                <ion-item *ngIf="data.centerData && data.centerData.direction" [languageRouter]="['como-llegar']">
                  <ion-icon slot="start" name="location-sharp"></ion-icon>
                  <ion-label>{{ data.centerData.direction }} {{ data.centerData.location }}</ion-label>
                </ion-item>
                <ion-item target="_blank" *ngIf="data.socialMedia && data.socialMedia.contactPhone">
                  <ion-icon slot="start" name="call"></ion-icon>
                  <ion-label><a href="tel:{{ data.socialMedia.contactPhone }}"> {{ data.socialMedia.contactPhone }}</a>
                    <ion-label *ngIf="tenantByUrl === 'almada'">{{ 'FOOTER.COST_OF_CALL' | translate}}</ion-label>
                  </ion-label>
                </ion-item>
                <ion-item target="_blank" *ngIf="data.socialMedia && data.socialMedia.generalClients" detail="false"
                  href="mailto:{{ data.socialMedia.generalClients }}">
                  <ion-icon slot="start" name="mail-sharp"></ion-icon>
                  <ion-label>{{ data.socialMedia.generalClients }}</ion-label>
                </ion-item>
              </ion-list>
            </ion-col>

            <ion-col class="sections-list" size-xs="12" size-sm="6" size-md="6" size-lg="5">
              <p class="title">{{"FOOTER.PRACTICAL_INFO" |translate}}</p>
              <ion-list lines="none" *ngIf="enabledModules$ | async as modules">
                <ion-item detail="false" [languageRouter]="['tiendas']" button>{{ 'FOOTER.SHOPS' | translate
                  }}</ion-item>
                <ion-item detail="false"
                  [languageRouter]="hasOnlyRestoration ? ['restaurantes'] : ['ocio-y-restaurantes']" button>
                  {{ (hasOnlyRestoration ? 'FOOTER.RESTORATION' : 'FOOTER.LEISURE') | translate }} </ion-item>
                <ion-item [languageRouter]="['cartelera-de-cine']" *ngIf="tenantHasCinema" detail="false" button> {{
                  'FOOTER.BILLBOARD' | translate }}</ion-item>
                <ion-item detail="false" [languageRouter]="['promociones']" button>{{ 'FOOTER.PROMOTIONS' | translate }}
                </ion-item>
                <!-- <ion-item detail="false" [languageRouter]="['agenda']" button>{{ 'FOOTER.AGENDA' | translate }}</ion-item> -->
                <ion-item detail="false" *ngIf="modules.includes('BLOG')" href="{{ blogLink }}" button> {{ 'FOOTER.BLOG'
                  |
                  translate }}
                </ion-item>
                <ion-item detail="false" [languageRouter]="['planos']" button>{{ 'FOOTER.MAPS' | translate }}</ion-item>
                <ion-item detail="false" [languageRouter]="['servicios']" button>{{ 'FOOTER.SERVICES' | translate }}
                </ion-item>
                <ion-item detail="false" [languageRouter]="['el-centro']" button>
                  {{ 'SECTIONS.THE_MALL' | translate }}
                </ion-item>
                <ion-item detail="false" [languageRouter]="['contacto']" button>
                  {{ 'SECTIONS.CONTACT' | translate }}
                </ion-item>
                <!-- <ion-item *ngIf="fidelityCardName !== undefined" detail="false" [languageRouter]="[fidelityCardUrl]"
                button>
                {{ fidelityCardName }}
              </ion-item> -->
              </ion-list>
            </ion-col>

            <ion-col class="col-social" size-xs="12" size-sm="6" size-md="auto" size-lg="3">

              <div class="footer-social">
                <ion-button *ngIf="data.socialMedia.instagram" [href]="data.socialMedia.instagram" target="_blank"
                  shape="round" size="small" color="light" fill="solid">
                  <ion-icon name="logo-instagram"></ion-icon>
                </ion-button>
                 <ion-button *ngIf="data.socialMedia.tiktok" [href]="data.socialMedia.tiktok" target="_blank"
                  shape="round" size="small" color="light" fill="solid">
                  <ion-icon name="logo-tiktok"></ion-icon>
                </ion-button>
              
                <ion-button *ngIf="data.socialMedia.facebook" [href]="data.socialMedia.facebook" target="_blank"
                  shape="round" size="small" color="light" fill="solid">
                  <ion-icon name="logo-facebook"></ion-icon>
                </ion-button>
                <ion-button *ngIf="data.socialMedia.tripadvisor" [href]="data.socialMedia.tripadvisor" target="_blank"
                  shape="round" size="small" color="light" fill="solid">
                  <i class="icon-tripadvisor"></i>
                </ion-button>
                <ion-button *ngIf="data.socialMedia.youtube" [href]="data.socialMedia.youtube" target="_blank"
                  shape="round" size="small" color="light" fill="solid">
                  <ion-icon name="logo-youtube"></ion-icon>
                </ion-button>
                <ion-button *ngIf="data.socialMedia.whatsapp" [href]="data.socialMedia.whatsapp" target="_blank"
                  shape="round" size="small" color="light" fill="solid">
                  <ion-icon name="logo-whatsapp"></ion-icon>
                </ion-button>
                 <ion-button *ngIf="data.socialMedia.pinterest" [href]="data.socialMedia.pinterest" target="_blank"
                  shape="round" size="small" color="light" fill="solid">
                  <ion-icon name="logo-pinterest"></ion-icon>
                </ion-button>
              </div>

              <div class="stores-container">
                <ion-button *ngIf="data.socialMedia && data.socialMedia.android" [href]="data.socialMedia.android"
                  target="_blank" color="dark" expand="block" class="app-store-button footer-button" href="#">
                  <ion-icon name="logo-google-playstore"></ion-icon>
                  Google Play
                </ion-button>
                <ion-button *ngIf="data.socialMedia && data.socialMedia.apple" [href]="data.socialMedia.apple"
                  target="_blank" color="dark" expand="block" class="app-store-button footer-button" href="#">
                  <ion-icon name="logo-apple"></ion-icon>
                  App Store
                </ion-button>
              </div>

            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div class="footer-bottom-row">
        <ion-grid class="container">
          <ion-row class="copyright ion-justify-content-between ion-align-items-end">
            <ion-col size-xs="12" size-sm="5" size-md="5"> © {{ year }} {{ tenantName }} </ion-col>
            <ion-col class="logos-footer" size-xs="12" size-sm="auto" size-md="auto">
              <p *ngIf="tenantByUrl !== 'vilamarina' && tenantByUrl !== 'bonaire'">{{'FOOTER.MANAGED_BY' | translate}}</p>
              <div class="logos-container">
                <a target="_blank" *ngIf="tenantByUrl !== 'vilamarina' && tenantByUrl !== 'bonaire'" [href]="footerURL"></a>
              </div>
            </ion-col>

            <ion-col size-xs="12" size-sm="5" size-md="5" class="footer-legal">
              <div class="social-links">
                <a class="live-logo" target="_blank" [href]="intranetURL">
                  <img src="../../../../assets/images/logo-live.png" alt="">
                </a>
                <ng-container *ngIf="employeeLink">
                  <!-- <span>|</span> -->
                  <a href="{{ employeeLink }}" target="_blank">
                    {{ 'FOOTER.JOBS' | translate }}
                  </a>
                </ng-container>
              </div>

              <div class="legals">
                <a [href]="'/' + language + '/' + localizeURL('aviso-legal')" target="_blank">{{ 'FOOTER.LEGAL_NOTICE' |
                  translate }}</a> |
                <a [href]="'/' + language + '/' + localizeURL('politica-de-privacidad')" target="_blank">{{
                  'FOOTER.PRIVACY_POLICY' | translate }}</a> |
                <a [href]="'/' + language + '/' + localizeURL('politica-de-cookies')" target="_blank">{{
                  'FOOTER.COOKIES_POLICY' | translate }}</a>
                 <a *ngIf="tenantName === 'Almada Forum'" class="complaints-book"
                  href="https://www.livroreclamacoes.pt/inicio" target="_blank">|{{
                  'FOOTER.COMPLAINTS_BOOK' | translate }}</a>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ng-container>
  </div>
</footer>
